module.exports = __webpack_public_path__ + "media/customizations/woodcreek/logo-7386f4dc089b524aca2baf9c760f85a0.png";